import { render } from "./TernButtonCTA.vue?vue&type=template&id=cfe2f894&scoped=true"
import script from "./TernButtonCTA.vue?vue&type=script&lang=js"
export * from "./TernButtonCTA.vue?vue&type=script&lang=js"

import "./TernButtonCTA.vue?vue&type=style&index=0&id=cfe2f894&scoped=true&lang=css"

import exportComponent from "/Users/tavishi/Desktop/Tilly/code/tern-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfe2f894"]])

export default __exports__